import React, { useContext, useState } from 'react';
import PageTitleAndSnackBar from '../../components/common/PageTitleAndSnackBar'
import DContext from '../../context/DContext';
import CreateClientModal from '../../components/modals/CreateClientModal';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import ContentLoader from '../../components/loader/ContentLoader';
import { makeApiCall } from '../../services/httpService_notinuse';
import toast from 'react-hot-toast';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../config/apiConfig';
import { capitalizeFirstLetter, titleCase } from '../../helper/stringMethods';


const Profile = () => {


  const { authState, authDispatch, logout } = useContext(DContext);
  const { user, user_role } = authState;

  const [passwordDivLoading, setPasswordDivLoading] = useState(false);
  const [show, setShow] = useState(false);
  const toggleModal = () => {
    show === true ? setShow(false) : setShow(true);
  }

  const [passwordInfo, setPasswordInfo] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: ""
  })

  const showSwal = (title, text, icon) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon // 'success' | 'error' | 'warning' | 'info' | 'question'
    })
  }

  const handleChange = (e) => {
    setPasswordInfo({ ...passwordInfo, [e.target.name]: e.target.value });
  }

  const changePassword = async (e) => {
    try {
      setPasswordDivLoading(true);
      e.preventDefault();
      console.log("final form data", passwordInfo);
      let apiUrl = `${API_BASE_URL}/api/users/change-password`;
      let apiRes = await makeApiCall("POST", passwordInfo, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        showSwal("Success", apiRes.message, "success");
        //setFlightDetail(initialFlightDetail);
      } else {
        console.log(apiRes?.response?.data?.message);
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "warning");
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setPasswordDivLoading(false);
    }
  }

return (
    <>
      <PageTitleAndSnackBar pageTitle="Profile" />

      <section className="section profile">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-xl-10">

              <div className="card border-0 shadow-sm" style={{ borderRadius: "16px", overflow: "hidden" }}>

                {/* ── Banner ── */}
                <div style={{
                  background: "linear-gradient(135deg, #2d4f8e 0%, #5b84c4 100%)",
                  padding: "18px 20px", position: "relative", overflow: "hidden"
                }}>
                  <div style={{ position: "absolute", top: "-40px", right: "-40px", width: "180px", height: "180px", borderRadius: "50%", background: "rgba(255,255,255,0.05)" }}></div>
                  <div style={{ position: "absolute", bottom: "-30px", right: "220px", width: "100px", height: "100px", borderRadius: "50%", background: "rgba(255,255,255,0.04)" }}></div>

                  <div className="d-flex align-items-center gap-3">
                    {/* Avatar */}
                    <div style={{
                      width: "58px", height: "58px", borderRadius: "50%", flexShrink: 0,
                      border: "3px solid rgba(255,255,255,0.45)", overflow: "hidden"
                    }}>
                      <img
                        src={`https://ui-avatars.com/api/?name=${user?.name}&size=200&background=2d4f8e&color=fff`}
                        alt="Profile"
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    </div>

                    {/* Info */}
                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                      <h5 style={{
                        color: "white", fontWeight: "800", fontSize: "16px", marginBottom: "3px",
                        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"
                      }}>
                        {capitalizeFirstLetter(user?.name)}
                      </h5>
                      <div className="d-flex align-items-center gap-2 mb-2" style={{ flexWrap: "wrap" }}>
                        <span style={{ fontSize: "10px", color: "rgba(255,255,255,0.65)", fontWeight: "700", letterSpacing: "0.8px" }}>
                          {user?.code?.toUpperCase()}
                        </span>
                        <span style={{ width: "3px", height: "3px", borderRadius: "50%", background: "rgba(255,255,255,0.35)", flexShrink: 0 }}></span>
                        <span style={{
                          fontSize: "10px", fontWeight: "800", letterSpacing: "0.8px",
                          background: "rgba(255,255,255,0.15)", color: "white",
                          borderRadius: "12px", padding: "2px 10px"
                        }}>
                          {user?.role?.role_type?.toUpperCase()}
                        </span>
                      </div>

                      {/* Contact items — inline with ellipsis on overflow */}
                      <div className="d-flex align-items-center gap-2" style={{ flexWrap: "wrap" }}>
                        {[
                          { value: user?.email, icon: "bi-envelope-fill" },
                          { value: user?.phone, icon: "bi-telephone-fill" },
                          { value: user?.status, icon: "bi-circle-fill" },
                        ].map((item, i) => (
                          <span key={i} style={{
                            fontSize: "11px", color: "rgba(255,255,255,0.82)",
                            display: "flex", alignItems: "center", gap: "4px",
                            maxWidth: "170px", overflow: "hidden"
                          }}>
                            <i className={`bi ${item.icon}`} style={{ fontSize: "10px", flexShrink: 0 }}></i>
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {item.value || "—"}
                            </span>
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* ── Tab Nav — icon-only on mobile ── */}
                <div style={{ background: "#f8f9fe", borderBottom: "1px solid #eef0f8", padding: "0 16px" }}>
                  <ul className="nav" style={{ gap: "2px", flexWrap: "nowrap", overflowX: "auto" }}>
                    {[
                      { target: "profile-overview", label: "Overview", icon: "bi-person-fill" },
                      { target: "profile-edit", label: "Edit Profile", icon: "bi-pencil-fill" },
                      { target: "profile-settings", label: "Settings", icon: "bi-gear-fill" },
                      { target: "profile-change-password", label: "Password", icon: "bi-shield-lock-fill" },
                    ].map(({ target, label, icon }, i) => (
                      <li className="nav-item" key={target}>
                        <button
                          className={`nav-link d-flex align-items-center gap-2 border-0 ${i === 0 ? "active" : ""}`}
                          data-bs-toggle="tab"
                          data-bs-target={`#${target}`}
                          style={{
                            padding: "12px 12px", fontWeight: "600", fontSize: "13px",
                            background: "transparent", borderRadius: "0", color: "#a0aec0",
                            borderBottom: "2px solid transparent",
                            transition: "all 0.15s", whiteSpace: "nowrap"
                          }}
                          onMouseEnter={e => { e.currentTarget.style.color = "#1e3a6e" }}
                          onMouseLeave={e => { if (!e.currentTarget.classList.contains("active")) e.currentTarget.style.color = "#a0aec0" }}
                        >
                          <i className={`bi ${icon}`} style={{ fontSize: "13px" }}></i>
                          <span className="d-none d-sm-inline">{label}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* ── Tab Content ── */}
                <div className="tab-content p-3">

                  {/* Overview Tab */}
                  <div className="tab-pane fade show active" id="profile-overview">
                    <div className="row g-3">
                      {[
                        { label: "Full Name", value: capitalizeFirstLetter(user?.name), icon: "bi-person-fill", iconBg: "#eef0ff", iconColor: "#2d4f8e" },
                        { label: "Email", value: user?.email, icon: "bi-envelope-fill", iconBg: "#e8f5fe", iconColor: "#0e7ab8" },
                        { label: "Phone", value: user?.phone, icon: "bi-telephone-fill", iconBg: "#edfaf4", iconColor: "#1a7a55" },
                        { label: "Status", value: user?.status, icon: "bi-circle-fill", iconBg: "#edfaf4", iconColor: "#1a7a55" },
                      ].map(({ label, value, icon, iconBg, iconColor }) => (
                        <div className="col-md-6" key={label}>
                          <div className="d-flex align-items-center gap-3 p-3 rounded-3"
                            style={{ background: "#f8f9fe", border: "1.5px solid #eef0f8" }}>
                            <div style={{
                              width: "38px", height: "38px", borderRadius: "10px", flexShrink: 0,
                              background: iconBg, display: "flex", alignItems: "center", justifyContent: "center"
                            }}>
                              <i className={`bi ${icon}`} style={{ fontSize: "14px", color: iconColor }}></i>
                            </div>
                            <div style={{ minWidth: 0 }}>
                              <div style={{ fontSize: "10px", fontWeight: "700", color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.7px" }}>
                                {label}
                              </div>
                              <div style={{ fontSize: "13px", fontWeight: "600", color: "#1e3a6e", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {value || "—"}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Edit Profile Tab */}
                  <div className="tab-pane fade" id="profile-edit">
                    <form>
                      <div className="text-center mb-3">
                        <div style={{ position: "relative", display: "inline-block" }}>
                          <img
                            src={`https://ui-avatars.com/api/?name=${user?.name}&size=200&background=2d4f8e&color=fff`}
                            alt="Profile" className="rounded-circle"
                            style={{ width: "68px", height: "68px", border: "4px solid #dde3ef" }}
                          />
                          <label style={{
                            position: "absolute", bottom: "0", right: "0",
                            width: "26px", height: "26px", borderRadius: "50%",
                            background: "#2d4f8e",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            cursor: "pointer", border: "2px solid white"
                          }}>
                            <i className="bi bi-camera-fill text-white" style={{ fontSize: "11px" }}></i>
                          </label>
                        </div>
                      </div>

                      <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <i className="bi bi-person-fill" style={{ color: "#2d4f8e", fontSize: "13px" }}></i>
                          <span style={{ fontSize: "11px", fontWeight: "700", color: "#2d4f8e", textTransform: "uppercase", letterSpacing: "0.7px" }}>Basic Info</span>
                        </div>
                        <div className="row g-2">
                          {[
                            { id: "floatingName", label: "Full Name", type: "text", icon: "bi-person" },
                            { id: "floatingCompany", label: "Company", type: "text", icon: "bi-building" },
                            { id: "floatingJob", label: "Job", type: "text", icon: "bi-briefcase" },
                            { id: "floatingPhone", label: "Phone", type: "number", icon: "bi-telephone" },
                            { id: "floatingEmail", label: "Email", type: "email", icon: "bi-envelope" },
                            { id: "floatingCountry", label: "Country", type: "text", icon: "bi-globe" },
                          ].map(({ id, label, type, icon }) => (
                            <div className="col-6 col-md-4" key={id}>
                              <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                                {label}
                              </label>
                              <div className="input-group input-group-sm">
                                <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #e8ecf4", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                                  <i className={`bi ${icon}`} style={{ color: "#2d4f8e", fontSize: "12px" }}></i>
                                </span>
                                <input type={type} className="form-control form-control-sm" id={id} placeholder={label}
                                  style={{ border: "1.5px solid #e8ecf4", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }} />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <i className="bi bi-geo-alt-fill" style={{ color: "#2d4f8e", fontSize: "13px" }}></i>
                          <span style={{ fontSize: "11px", fontWeight: "700", color: "#2d4f8e", textTransform: "uppercase", letterSpacing: "0.7px" }}>Additional Info</span>
                        </div>
                        <div className="row g-2">
                          <div className="col-12">
                            <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Address</label>
                            <div className="input-group input-group-sm">
                              <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #e8ecf4", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                                <i className="bi bi-map" style={{ color: "#2d4f8e", fontSize: "12px" }}></i>
                              </span>
                              <input type="text" className="form-control form-control-sm" placeholder="Address"
                                style={{ border: "1.5px solid #e8ecf4", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-12">
                            <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>About</label>
                            <textarea className="form-control form-control-sm" placeholder="Tell us about yourself..." rows={3}
                              style={{ borderRadius: "8px", border: "1.5px solid #e8ecf4", background: "white", fontSize: "13px", resize: "none" }}></textarea>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end">
                        <button type="submit" className="btn btn-sm fw-semibold d-flex align-items-center gap-2 text-white"
                          style={{ background: "linear-gradient(135deg, #2d4f8e, #5b84c4)", borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(45,79,142,0.22)", fontSize: "13px", height: "36px", padding: "0 20px" }}>
                          <i className="bi bi-floppy-fill"></i> Save Changes
                        </button>
                      </div>
                    </form>
                  </div>

                  {/* Settings Tab */}
                  <div className="tab-pane fade" id="profile-settings">
                    <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                      <div className="d-flex align-items-center gap-2 mb-3">
                        <i className="bi bi-bell-fill" style={{ color: "#2d4f8e", fontSize: "13px" }}></i>
                        <span style={{ fontSize: "11px", fontWeight: "700", color: "#2d4f8e", textTransform: "uppercase", letterSpacing: "0.7px" }}>Email Notifications</span>
                      </div>
                      <div className="d-flex flex-column gap-2">
                        {[
                          { id: "changesMade", label: "Changes made to your account", checked: true, disabled: false },
                          { id: "newProducts", label: "Information on new products and services", checked: true, disabled: false },
                          { id: "proOffers", label: "Marketing and promo offers", checked: false, disabled: false },
                          { id: "securityNotify", label: "Security alerts", checked: true, disabled: true },
                        ].map(({ id, label, checked, disabled }) => (
                          <div key={id} className="d-flex align-items-center justify-content-between p-3 rounded-3"
                            style={{ background: "white", border: "1.5px solid #eef0f8" }}>
                            <div className="d-flex align-items-center gap-2" style={{ minWidth: 0, flex: 1, marginRight: "12px" }}>
                              <i className="bi bi-envelope-fill" style={{ color: "#2d4f8e", fontSize: "12px", flexShrink: 0 }}></i>
                              <span style={{ fontSize: "13px", fontWeight: "500", color: "#4b5563", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                              {disabled && (
                                <span style={{ fontSize: "10px", fontWeight: "700", background: "#eef0ff", color: "#2d4f8e", borderRadius: "5px", padding: "1px 6px", flexShrink: 0 }}>
                                  REQ
                                </span>
                              )}
                            </div>
                            <div className="form-check form-switch mb-0" style={{ flexShrink: 0 }}>
                              <input className="form-check-input" type="checkbox" id={id} defaultChecked={checked} disabled={disabled}
                                style={{ width: "36px", height: "20px", cursor: disabled ? "not-allowed" : "pointer" }} />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button type="submit" className="btn btn-sm fw-semibold d-flex align-items-center gap-2 text-white"
                        style={{ background: "linear-gradient(135deg, #2d4f8e, #5b84c4)", borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(45,79,142,0.22)", fontSize: "13px", height: "36px", padding: "0 20px" }}>
                        <i className="bi bi-floppy-fill"></i> Save Changes
                      </button>
                    </div>
                  </div>

                  {/* Change Password Tab */}
                  {passwordDivLoading ? (
                    <ContentLoader loaderType="circleSpin" />
                  ) : (
                    <div className="tab-pane fade" id="profile-change-password">
                      <form onSubmit={changePassword}>
                        <div className="row justify-content-center">
                          <div className="col-12 col-md-8 col-lg-6">
                            <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                              <div className="d-flex align-items-center gap-2 mb-3">
                                <i className="bi bi-shield-lock-fill" style={{ color: "#2d4f8e", fontSize: "13px" }}></i>
                                <span style={{ fontSize: "11px", fontWeight: "700", color: "#2d4f8e", textTransform: "uppercase", letterSpacing: "0.7px" }}>Password</span>
                              </div>
                              <div className="d-flex flex-column gap-2">
                                {[
                                  { id: "floatingcurrentPassword", name: "currentPassword", label: "Current Password", icon: "bi-lock" },
                                  { id: "floatingnewPassword", name: "newPassword", label: "New Password", icon: "bi-lock-fill" },
                                  { id: "floatingrenewPassword", name: "confirmNewPassword", label: "Confirm New Password", icon: "bi-shield-lock" },
                                ].map(({ id, name, label, icon }) => (
                                  <div key={id}>
                                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                                      {label}
                                    </label>
                                    <div className="input-group input-group-sm">
                                      <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #e8ecf4", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                                        <i className={`bi ${icon}`} style={{ color: "#2d4f8e", fontSize: "12px" }}></i>
                                      </span>
                                      <input type="password" className="form-control form-control-sm" id={id} placeholder={label} name={name} onChange={handleChange}
                                        style={{ border: "1.5px solid #e8ecf4", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }} />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                            <button type="submit" className="btn btn-sm fw-semibold d-flex align-items-center gap-2 text-white w-100 justify-content-center"
                              style={{ background: "linear-gradient(135deg, #2d4f8e, #5b84c4)", borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(45,79,142,0.22)", fontSize: "13px", height: "38px" }}>
                              <i className="bi bi-shield-check"></i> Change Password
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}

                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <CreateClientModal showModal={show} handleToggleModal={toggleModal} />
    </>
  );
}

export default Profile;